module.exports = __webpack_public_path__ + "static/media/loadshare_networks.80786a6b.png";